export type AnalyticsEventParams = { [key: string]: any } | undefined;

const PII_KEYS = new Set<string>([
  'user_email',
  'userEmail',
  'portal_user_email',
  'portal_user_email_id',
  'portal_user_id',
  'portalUserId',
  'portal_user_firstName',
  'portal_user_lastName',
  'portal_user_phone',
  'portal_user_phone_number',
  'portal_user_address',
  'forgot_password_request_user_email',
  'password_change_user_email',
  'email_id',
  'username',
  'email',
  'phone',
  'phone_number',
  'phone_no',
  'phoneNo',
  'phoneNumber',
  'first_name',
  'middle_name',
  'last_name',
  'fname',
  'mname',
  'lname',
  'firstName',
  'middleName',
  'lastName',
  'address',
  'notes',
  'zip_code',
  'zipCode',
  'zipcode',
  'date_of_birth',
  'birthdate',
  'birth_date',
  'birthDate',
  'dob',
  'member_ref',
  'memberRef',
  'client_user_id',
  'client_id',
  'clientUserId',
  'uid',
  'target_uid',
  'targetUid',
  'userid',
  'userId',
  'user_id',
  'user_ids',
  'userIds',
  'member_id',
  'memberId',
  'caregiver_id',
  'caregiverId',
  'previous_caregiver_id',
  'previousCaregiverId',
  'new_caregiver_id',
  'newCaregiverId',
  'source_profile_id',
  'sourceProfileId',
  'target_profile_id',
  'targetProfileId',
  'source_member_id',
  'sourceMemberId',
  'recipient_ids',
  'recipientIds',
  'fileName',
  'file_name'
]);

const PII_KEYS_LOWER = new Set<string>(Array.from(PII_KEYS).map(k => k.toLowerCase()));

export function sanitizeAnalyticsEventParams(eventParams?: { [key: string]: any }): AnalyticsEventParams {
  if (!eventParams) return eventParams;

  const sanitized: { [key: string]: any } = {};

  for (const [key, value] of Object.entries(eventParams)) {
    if (value === undefined) continue;

    if ((key === 'page_path' || key === 'page_referrer' || key === 'api_url' || key === 'referrer') && typeof value === 'string') {
      sanitized[key] = sanitizePagePath(value);
      continue;
    }

    if ((key === 'search_query' || key === 'search_term') && typeof value === 'string') {
      const sanitizedKey = key === 'search_query' ? 'search_query' : 'search_term';
      sanitized[`${sanitizedKey}_present`] = value.length > 0;
      sanitized[`${sanitizedKey}_length`] = value.length;
      continue;
    }

    if (PII_KEYS.has(key) || PII_KEYS_LOWER.has(key.toLowerCase())) {
      continue;
    }

    if (typeof value === 'string') {
      if (looksLikeEmail(value)) {
        continue;
      }
      if (/(phone|mobile)/i.test(key) && looksLikePhone(value)) {
        continue;
      }
    }

    sanitized[key] = value;
  }

  return sanitized;
}

function sanitizePagePath(path: string): string {
  const noQueryOrHash = path.split('?')[0].split('#')[0];

  let pathOnly = noQueryOrHash;
  if (/^https?:\/\//i.test(noQueryOrHash)) {
    try {
      pathOnly = new URL(noQueryOrHash).pathname;
    } catch {
      pathOnly = noQueryOrHash;
    }
  }

  const parts = pathOnly.split('/').filter(Boolean);

  const sanitizedParts = parts.map(seg => {
    if (/^\d+$/.test(seg)) return ':id';
    if (/\d/.test(seg) && seg.length >= 6) return ':id';
    if (/^[0-9a-fA-F-]{8,}$/.test(seg)) return ':id';
    if (looksLikeEmail(seg)) return ':email';
    return seg;
  });

  return '/' + sanitizedParts.join('/');
}

function looksLikeEmail(value: string): boolean {
  return /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(value);
}

function looksLikePhone(value: string): boolean {
  const digits = value.replace(/[^\d]/g, '');
  return digits.length >= 10;
}


